import { Link } from "react-router-dom";

export default function FourZeroFour() {
  return (
    <>
      <div className="cart-page-wrapper w-full">
        <div className="container-x mx-auto">
          <div className="empty-card-wrapper w-full">
            <h1 className="sm:text-xl text-base font-semibold text-center mb-5">
              {`Sorry! We can't Find that page!`}
            </h1>
            <div className="flex justify-center items-center w-full">
              <Link to="/">
                <div className="sm:mb-10 mb-0 transform sm:scale-100">
                  <img src="/assets/images/Ooopss.png" />
                </div>
                <div data-aos="fade-up" className="empty-content w-full">
                  <div className="flex justify-center w-full ">
                    <div className="h-[50px] ">
                      <button className="bg-white hover:bg-blue-100 text-blue-800 font-semibold py-2 px-4 border border-blue-400 rounded-full shadow">
                        Go Home
                      </button>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
